import Vue from 'vue'
import router from './../router'
import {getSignupToken} from '../utils/auth/authService'
import {getUser} from '../utils/user/getUserDetails'
import {registerUser} from '../utils/auth/authService'
import {getAllBanks} from  '../utils/helpers/utilitiesService'
import {getWallets} from  '../utils/wallet-transactions/walletService'
import appConfig from '@/config';
const STAGING_PASSWORD = appConfig.api.staginPassword;



export default {
  enableActions(context, enableActions) {
    context.commit('updateEnableActions', enableActions);
  },
  
  // Fetch Settlement Accounts
  createUser(context) {
    let signupPayload = {
      fullName: context.state.authUser.firstName + ' ' + context.state.authUser.lastName,
      email:context.state.authUser.email,
      city:context.state.authUser.city,
      state:context.state.authUser.state,
      address:context.state.authUser.address,
      phoneNumber: context.state.authUser.phoneCountryCode + context.state.authUser.phonenumber,
      password:context.state.authUser.password,
      originalPassword:context.state.authUser.password,
      businessName: context.state.authUser.businessName,
      businessType: context.state.authUser.businessType,
      businessDescription: context.state.authUser.businessDescription,
      currencies: context.state.authUser.currenciesSelected,
    };
    registerUser(signupPayload).then((response) => {
      if (response.status === 200 && response.data && response.data.data) {
        window.localStorage.setItem('userID', response.data.data.user.user_id);
        window.localStorage.setItem('merchantId', response.data.data.user.merchant_id);
        return getSignupToken(true);
      } else {
        console.log('user not created')
      }
    })
    .then((response) => {
      if(response.status === 200){
        this.userErrors = [];
        let registerToken = response.data.token_type + ' ' + response.data.access_token;
        Vue.$cookies.set('staging_access_token', registerToken);
        signupPayload.password = STAGING_PASSWORD;
        return registerUser(signupPayload, true);
      }
    })
    .then((resp) => {
      router.push('/overview');
      location.reload();

    })
    .catch((error) => {
      if (error.response.data && error.response.data.errors) {
        const keys = Object.keys(error.response.data.errors)[0]
        window.localStorage.setItem('signUpError', error.response.data.errors[keys][0]);
      } else if (error.response.data && error.response.data.message) window.localStorage.setItem('signUpError', error.response.data.message);
      else window.localStorage.setItem('signUpError', 'An error Occured on our server');
      
      setTimeout(() => { window.localStorage.removeItem('signUpError'); }, 10000)
    });
  },

  //this function calls the getAllBanks service.
  handleBanksFetch(context){
    let app = this;
    getAllBanks()
      .then(response =>{
        // console.log('banklistapi',response)
        if(response.status === 200){
          // console.log('bankgettinghere', response.data.data);
          response.data.data.forEach((bank)=>{
            context.commit('updateBanksList', {
              bankName:bank.name,
              bankCode:bank.code,
              bankCountryCode:bank.country,
            });
          });

        }

      })

      //catch error from the getWallets API and do something about the errors
      .catch(error =>{

      })
  },

  //this function calls the wallet service.
  handlePrimaryWalletFetch(context){
    let app = this;
    getWallets()
      .then(response =>{
        if(response.status === 200){
          response.data.data.forEach((wallet)=>{
            context.commit('updatePrimaryWalletCurrencies', {
              currencyCode: wallet.currency.shortCode,
              currencyId:wallet.id,
              currencyBalance:wallet.balance,
              currencyUref:wallet.uref,
              country: wallet.countryTag,
              countryName: wallet.currency.countryName,
              name: wallet.name,
            });
          });

        }

      })

      //catch error from the getWallets API and do something about the errors
      .catch(error =>{

      })
  },


}





// WEBPACK FOOTER //
// ./src/store/actions.js